import { IcBox, IcRoadAssistance, IcUsers } from '@/assets/images';
import {
  AgencyType,
  AssignedUnitShiftStatus,
  ICFSForm,
  TSeverity,
} from '@/models';

export const UnitResourceFormFields: Record<string, any> = {
  VEHICLE: {
    name: 'vehicles',
    type: 'autocomplete',
    label: 'Vehicles',
    errorLabel: 'vehicle',
    multiple: true,
    limitTags: 3,
    rules: {
      required: 'This field is required.',
    },
  },
  PEOPLE: {
    name: 'users',
    type: 'autocomplete',
    label: 'Employees',
    errorLabel: 'employee',
    multiple: true,
    limitTags: 3,
    rules: {
      required: 'This field is required.',
    },
  },
  EQUIPMENT: {
    name: 'equipments',
    type: 'autocomplete',
    label: 'Equipment',
    errorLabel: 'equipment resource',
    multiple: true,
    limitTags: 3,
    rules: {
      required: 'This field is required.',
    },
  },
  POLYGON_LAYER: {
    name: 'polygons',
    type: 'autocomplete',
    label: 'Polygons',
    errorLabel: 'polygon resource',
    multiple: true,
    limitTags: 3,
    rules: {
      required: 'This field is required.',
    },
  },
};

export const initFilterValues = {
  agencies: [],
  beat: '',
  agencyType: null,
  unitTypes: [],
  name: '',
};

export const agencyTypeItems = [
  {
    label: 'EMS',
    value: AgencyType.EMS,
  },
  {
    label: 'FIRE',
    value: AgencyType.FIRE,
  },
  {
    label: 'POLICE',
    value: AgencyType.POLICE,
  },
  {
    label: 'EMERGENCY MANAGEMENT',
    value: AgencyType.EMERGENCY_MANAGEMENT,
  },
  {
    label: 'MUNICIPAL SERVICES',
    value: AgencyType.MUNICIPAL_SERVICES,
  },
];

export const availableUnitActions = [
  {
    label: 'Assign',
    value: 'assign',
  },
  {
    label: 'Set off-duty',
    value: 'set-off-duty',
  },
];

export const availableHQUnitActions = [
  {
    label: 'Assign',
    value: 'assign',
  },
  {
    label: 'Assign to HQ',
    value: 'assignToHQ',
  },
  {
    label: 'Set off-duty',
    value: 'set-off-duty',
  },
];

export const unitShiftActionItems = [
  {
    label: 'Complete',
    value: AssignedUnitShiftStatus.COMPLETED,
  },
  {
    label: 'Cancel',
    value: AssignedUnitShiftStatus.CANCELED,
  },
];

export const unitShiftHQActionItems = [
  {
    label: 'Assign to call',
    value: 'assignToCall',
  },
  {
    label: 'Complete',
    value: AssignedUnitShiftStatus.COMPLETED,
  },
  {
    label: 'Cancel',
    value: AssignedUnitShiftStatus.CANCELED,
  },
];

export const unitShiftCallActionItems = [
  {
    label: 'Assign to HQ',
    value: 'assignToHQ',
  },
  {
    label: 'Complete',
    value: AssignedUnitShiftStatus.COMPLETED,
  },
  {
    label: 'Cancel',
    value: AssignedUnitShiftStatus.CANCELED,
  },
];

export const unitShiftReassignActionItems = [
  {
    label: 'Complete and reassign',
    value: AssignedUnitShiftStatus.COMPLETED,
  },
  {
    label: 'Cancel and reassign',
    value: AssignedUnitShiftStatus.CANCELED,
  },
  {
    label: 'Queue',
    value: AssignedUnitShiftStatus.QUEUED,
  },
];

export const unitShiftStandbyActionItems = [
  {
    label: 'Assign',
    value: 'assign',
  },
  {
    label: 'Set on duty',
    value: 'setOnDuty',
  },
];

export const unitShiftStandbyHQActionItems = [
  {
    label: 'Assign',
    value: 'assign',
  },
  {
    label: 'Assign to HQ',
    value: 'assignToHQ',
  },
  {
    label: 'Set on duty',
    value: 'setOnDuty',
  },
];

export const unitShiftViewItems = [
  {
    name: 'users',
    icon: IcUsers,
    items: [],
  },
  {
    name: 'vehicles',
    icon: IcRoadAssistance,
    items: [],
  },
  {
    name: 'equipments',
    icon: IcBox,
    items: [],
  },
];

export const unitFilterMenuTabs = [
  {
    value: 'currentFilter',
    label: 'Filter',
  },
  {
    value: 'savedFilters',
    label: 'Saved filters',
  },
];

export const severityItems = [
  {
    label: 'High',
    value: TSeverity.HIGH,
  },
  {
    label: 'Medium',
    value: TSeverity.MEDIUM,
  },
  {
    label: 'Low',
    value: TSeverity.LOW,
  },
];

export const CFSFormFields = [
  {
    key: 'address',
    title: 'Address information',
    name: 'addressInfo',
    items: [
      {
        name: 'address',
        label: 'Address',
        type: 'address',
        autoFocus: true,
        styles: {
          display: 'flex',
          xs: 12,
        },
      },
      {
        name: 'instructions',
        type: 'text',
        label: 'Instructions',
        styles: {
          xs: 12,
        },
        autoComplete: 'off',
      },
    ],
  },
  {
    key: 'emergency',
    title: 'Emergency detail',
    name: '',
    items: [
      {
        name: 'incidentCodes',
        type: 'autocomplete',
        label: 'Incident Code',
        multiple: true,
        limitTags: 3,
        items: [],
        styles: {
          xs: 6,
        },
      },
      {
        name: 'severity',
        type: 'tab',
        label: 'Severity',
        buttons: severityItems,
        styles: {
          xs: 6,
        },
      },
      {
        name: 'shortDescription',
        type: 'text',
        label: 'Short description',
        styles: {
          xs: 12,
        },
        autoComplete: 'off',
      },
      {
        name: 'assignedAgencies',
        label: 'Agencies',
        type: 'autocomplete',
        multiple: true,
        styles: {
          display: 'flex',
          xs: 12,
        },
      },
    ],
  },
];

export const cfsDefaultValues: ICFSForm = {
  addressInfo: {
    instructions: '',
  },
  assignedAgencies: [],
  shortDescription: '',
  incidentCodes: ['104', '111'],
  severity: TSeverity.MEDIUM,
  reporter: {
    isCallingForSelf: false,
    isKnowSubject: false,
    notOnLocation: false,
    notWantToBeSeen: false,
  },
};

export const cfs = {
  _id: 'mock',
  createdBy: {
    settings: {
      mapLayersPreferences: {},
      lastSeenReleaseVersion: null,
    },
    gpsTracker: null,
    _id: 'mock',
    email: 'carelink@static',
    status: 'ACTIVE',
    roles: [
      {
        role: 'ACCOUNT_ADMIN',
      },
    ],
    isLockedFromNewDevices: false,
    isLoginEnabled: true,
    notificationSound: null,
    createdAt: '2025-07-10T11:04:39.201Z',
    updatedAt: '2025-09-09T09:38:37.236Z',
    password: 'no',
    lastLoggedIn: '2025-09-09T09:38:37.235Z',
    firstName: 'Care',
    lastName: 'Link',
    phoneNumber: '+13213213123',
    profile: '687623cb72a92ad42dff09fc',
    stateId: null,
    fullName: 'Care Link',
    id: 'mock',
  },
  number: 'CFS000001',
  severity: 'MEDIUM',
  incidentCodes: [
    {
      _id: 'mock',
      code: '104',
      createdAt: '2025-07-10T14:28:09.385Z',
      description: 'Report to Your Station',
      requiredUnits: [
        {
          unitType: 'mock',
          number: 1,
        },
      ],
      updatedAt: '2025-07-10T14:28:09.385Z',
      id: 'mock',
    },
    {
      _id: 'mock',
      code: '111',
      createdAt: '2025-07-10T14:28:09.385Z',
      description: 'Disorderly Person',
      requiredUnits: [
        {
          unitType: 'mock',
          number: 2,
        },
        {
          unitType: 'mock',
          number: 2,
        },
      ],
      updatedAt: '2025-07-10T14:28:09.385Z',
      id: 'mock',
    },
  ],
  additionalInfo: [],
  reporter: {
    reportTime: '2025-09-09T09:19:21.791Z',
    isCallingForSelf: false,
    isKnowSubject: false,
    notOnLocation: false,
    notWantToBeSeen: false,
  },
  isReadyToDispatch: false,
  isClosed: false,
  emailSentAt: null,
  assignmentStatus: 'NEW',
  assignedAgencies: [],
  requiredUnits: [],
  assignedUnitShifts: [],
  unitShiftDistances: [],
  files: [],
  createdAt: '2025-09-09T09:19:21.792Z',
  updatedAt: '2025-09-09T09:19:21.792Z',
  id: 'mock',
  primaryReporter: null,
  names: 0,
  vehicles: 0,
  hasUnsetInvolvementName: false,
  calls: [],
};

export const formValues = {
  addressInfo: {
    address: {
      uniqueId: 0,
      addressNumber: '0',
      subAddress: '/',
      state: 'NY',
      zipcode: '10562',
      zipName: 'Ossining',
      pointType: 5,
      placeName: 'Ossining',
      completeStreetName: 'Westerly Road',
      status: 'ACTIVE',
      addressLabel: '/',
      country: 'US',
      point: {
        type: 'Point',
        coordinates: [-73.8700027, 41.1574968],
      },
      intersectionStreets: [],
      _id: 'mock',
      createdAt: '2025-07-17T10:17:01.040Z',
      updatedAt: '2025-09-11T12:32:35.832Z',
      normalized: '/',
      id: 'mock',
    },
    instructions: '/',
    locationPoints: [],
  },
  assignedAgencies: ['Agency name 01', 'agency name 02'],
  shortDescription: '/',
  incidentCodes: ['104', '111'],
  severity: 'HIGH',
  reporter: {
    isCallingForSelf: true,
    isKnowSubject: false,
    notOnLocation: false,
    notWantToBeSeen: false,
    contactPhoneNumber: '2111111111',
  },
};
